export default __webpack_public_path__ + "static/media/DSC_0837.458c22e9.JPG";